import Main from '@/pages/Member/Main'
import Applies from '@/pages/Member/Applies'
import Detail from '@/pages/Member/Detail'
import Import from '@/pages/Member/Import'
import Step1 from '@/pages/Member/Step1'
import Step2 from '@/pages/Member/Step2'
import Step3 from '@/pages/Member/Step3'
import Personal from '../pages/Member/Personal'

export default [
    {
        path: '',
        component: Main
    },
    {
        path: 'main',
        component: Main
    },
    {
        path: 'personal',
        component: Personal
    },
    {
        path: 'applies',
        component: Applies
    },
    {
        path: 'detail',
        component: Detail
    },
    {
        path: 'import',
        component: Import,
        children: [{
            path: '',
            component: Step1
        }, {
            path: 'step1',
            component: Step1
        }, {
            path: 'step2',
            component: Step2
        }, {
            path: 'step3',
            component: Step3
        }]
    }
]
